import React from "react";
import Button from "@ingka/button";
import Text from '@ingka/text';
import "../../app.scss"

interface OptionProps {
    children: React.ReactNode
}

export const PPSTemplate: React.FC<OptionProps> = ({children}) => {

  return (
    <div>
      <div className="grid">
        <div className="grid-title">
          <Text tagName="h2" textStyle="Heading.M">
            Product Propensity Scores
          </Text>
        </div>      
        <div className='grid-buttons'>
          <div className='nav-button'>
            <Button size="small" type="secondary">
              Settings
            </Button>
          </div>
          <div className='nav-button'>
            <Button size="small" href="#/ppsscores" type="emphasised" >
              Recent Requests
            </Button>
          </div>
          <div className='nav-button'>
            <Button size="small" href="#/ppsscorescreate" type="emphasised">
              New Request
            </Button>
          </div>
        </div>
      </div>
      <div className="grid">
        {children}
      </div>
    </div>
  )
}